import React from 'react';
import { connect } from 'react-redux';
import { getInspectAccess, INSPECT_ACCESS } from 'helpers/inspectAccess';
import InspectLanding from './InspectLanding';
import InspectAccessNotice from './InspectAccessNotice';
import './style.css';

// Route gate for the Inspect module (il-inspect-landing-page). The "on" tree is always the same,
// so the module is not remounted when the user-only notice appears after settings load.
export default function requireInspect(Wrapped) {
  function InspectGate(props) {
    const { inspectStatus, inspectViaUserOnly, ...rest } = props;
    if (inspectStatus === INSPECT_ACCESS.ON) {
      return (
        <div className="inspect-access-layout">
          {inspectViaUserOnly ? <InspectAccessNotice /> : null}
          <div className="inspect-access-layout-body">
            <Wrapped {...rest} />
          </div>
        </div>
      );
    }
    if (inspectStatus === INSPECT_ACCESS.OFF) {
      return <InspectLanding />;
    }
    return <div className="inner-page inspect-gate-pending" aria-busy="true" />;
  }
  InspectGate.displayName = 'requireInspect(' + (Wrapped.displayName || Wrapped.name || 'Component') + ')';

  function mapStateToProps(state) {
    var access = getInspectAccess(state);
    return { inspectStatus: access.status, inspectViaUserOnly: access.viaUserOnly };
  }

  return connect(mapStateToProps, {})(InspectGate);
}
